import { Action } from 'redux';

import { GeocodeDatasource } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export interface GeocodeDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function geocodeDatasource(contentInfo: IContentInfo): GeocodeDatasourceAction {
  return {
    type: GeocodeDatasource,
    contentInfo,
  };
}

export const isGeocodeDatasourceAction = isActionFactory<GeocodeDatasourceAction>(GeocodeDatasource);
